import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@store/authStore';

interface PrivateRouteProps {
  children: React.ReactNode;
  /** If provided, redirect to /login (or /dashboard) when user role is not in this list */
  allowedRoles?: string[];
}

/**
 * Route guard for authenticated users only.
 * Optionally restricts access by role — unauthorized users are redirected to /dashboard.
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const role = user?.role ?? '';
    if (!allowedRoles.includes(role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute;


